import { LinkCardTabs } from 'components/Card/CardTabs/LinkCardTabs';
import { TabsWrapper } from 'components/Card/CardTabs/CardTabs.styled';
import { LegalPolicyTabsTree } from 'configs/RoutesConfig';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import styled from 'styled-components';

const Wrap = styled.div`
  ${TabsWrapper} {
    flex-wrap: wrap;
    row-gap: var(--s2);
  }
`;

export const LegalPolicyTabs = () => {
  const { t } = useCommonTranslation();

  return (
    <Wrap>
      <LinkCardTabs tabs={LegalPolicyTabsTree(t)} withDivider />
    </Wrap>
  );
};
